import "core-js/modules/es.array.map";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import bankList from '@/const/bank';
import utilRules from '@/libs/rules';
var formData = {
  bankAccountName: '',
  bankAccount: '',
  bankName: '',
  bankNo: ''
};
var initForm = {
  billNo: '',
  relationNo: '',
  billDateRange: {
    start: '',
    end: ''
  }
};
import { cloneDeep } from 'lodash';

var rulelist = _toConsumableArray(Object.keys(formData).map(function (v) {
  return v;
}));

export default {
  meta: {
    title: '选择单据',
    auth: true,
    authorityValue: "store-transfers-manage"
  },
  name: 'walletProcess',
  data: function data() {
    var _this = this;

    return {
      initForm: initForm,
      forms: cloneDeep(initForm),
      request: {
        api: 'canTransferBills',
        params: cloneDeep(initForm),
        parser: function parser(res) {
          _this.extraData = res.extraData;
          return res;
        }
      },
      active: 1,
      Selection: [],
      form: _objectSpread(_objectSpread({}, formData), {}, {
        billList: []
      }),
      rules: utilRules(rulelist),
      options: bankList,
      extraData: {}
    };
  },
  methods: {
    handleSelectionChange: function handleSelectionChange(e) {
      this.Selection = e;
    },
    handleSearch: function handleSearch(values) {
      this.$set(this.request, 'params', values);
      this.$refs.baseTable.loadData();
    },
    nextStep: function nextStep() {
      if (this.active == 1) {
        this.form.billList = this.Selection.map(function (v) {
          return v.billId;
        });

        if (this.form.billList.length > 0) {
          this.active += 1;
          this.getCacheInfo();
        } else {
          YL.message('请选择订单', 'error');
        }
      } else {
        this.active -= 1;
      }
    },
    getCacheInfo: function getCacheInfo() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.$api.cacheInfo();

              case 2:
                data = _context.sent;
                _this2.form = _objectSpread(_objectSpread({}, _this2.form), data);
                _this2.options = bankList;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    onSubmit: function onSubmit() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.$refs['form'].validate( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
                    var params;
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            if (!valid) {
                              _context2.next = 7;
                              break;
                            }

                            params = _objectSpread(_objectSpread({}, _this3.form), {}, {
                              billList: _this3.Selection.map(function (v) {
                                return {
                                  billId: v.billId
                                };
                              })
                            });
                            _context2.next = 4;
                            return _this3.$api.transfer(params);

                          case 4:
                            YL.message('提交申请');
                            _this3.form = _objectSpread(_objectSpread({}, formData), {}, {
                              billList: []
                            });

                            _this3.$router.replace('/walletSubmit');

                          case 7:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }
};